import { TgtLogger, TgtMeter } from '@measurement/opentelemetry-web'

// Known third-party / browser noise that has no actionable signal for us.
// Filtered out before reporting to keep observability signal clean.
const NOISE_PATTERNS = [
  /extension\//i,
  /chrome-extension:\/\//i,
  /moz-extension:\/\//i,
  /metamask/i,
  /resizeobserver loop/i,
]

const isNoiseError = (error) => {
  const message = error?.message || String(error)
  return NOISE_PATTERNS.some((pattern) => pattern.test(message))
}

const errorCounter = TgtMeter.createCounter('frontend.error.count', {
  description: 'Counts frontend errors captured by trackError',
})

/**
 * Central error-reporting entry point. Logs to Kibana via TgtLogger and
 * increments a Grafana-queryable counter via TgtMeter. Never throws.
 *
 * @param {Error} error
 * @param {Object} [options]
 * @param {'uncaught'|'unhandled_promise'|'error_boundary'|'critical'} [options.type]
 * @param {string} [options.page]
 * @param {string} [options.component]
 * @param {Object} [options.extra]
 */
export const trackError = (error, options = {}) => {
  try {
    if (isNoiseError(error)) {
      return
    }

    const { type = 'critical', page, component, extra } = options

    TgtLogger.error(error?.message || String(error), {
      nonIndexedFields: {
        errorName: error?.name,
        errorMessage: error?.message,
        stack: error?.stack,
        errorType: type,
        clientTimestamp: new Date().toISOString(),
        page,
        component,
        extra,
      },
    })

    errorCounter.add(1, {
      error_type: type,
      error_name: error?.name || 'Error',
      error_message: (error?.message || '').slice(0, 100),
      page,
      component,
    })
  } catch (trackingError) {
    // Telemetry must never crash the app.

    console.error('[errorTracking] failed to report error', trackingError)
  }
}

export default trackError
